import { mapState } from 'vuex';
export default {
  name: 'MediaFileUpload',
  props: {
    type: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'text/csv'
    },
    title: {
      type: String,
      default: ''
    },
    buttonIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      file: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    onUploadBtnClick() {
      // eslint-disable-next-line no-empty-function
      window.addEventListener('focus', () => {}, {
        once: true
      });
      this.$refs.file.click();
    },
    async handleFileUpload(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let file = input.files[0];
        try {
          let fileContents = await this.readUploadedFileAsText(file);
          let result = fileContents;
          this.file = result;
        } catch (e) {
          this.file = e.message;
        }
        this.$emit('file', this.file);
        event.target.value = '';
      }
    },
    readUploadedFileAsText(file) {
      let fileReader = new FileReader();
      return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
          fileReader.abort();
          reject(this.$i18n_t('NiotaClassic.Devices.snacks.fileUploadError'));
        };
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.readAsText(file);
      });
    }
  }
};